import React from 'react'
import { SponsorsList } from '../components/common'

const Sponsors = () => {
    return (
        <SponsorsList />
    )
}

export default Sponsors
